/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/asana" */ '@atlassian/logo-third-party/asana'
		).then((m) => m.AsanaIcon),
	{ moduleId: '@atlassian/logo-third-party/asana' },
);

const LazyForgeUnitoAsanaProdIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-asana-prod" */ './utils').then(
			(m) => m.ForgeUnitoAsanaProdIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-prod/icon' },
);

const LazyForgeUnitoAsanaProdSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-asana-prod-search-result" */ './utils').then(
			(m) => m.ForgeUnitoAsanaProdSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUnitoAsanaProdIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgeUnitoAsanaProdIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const ForgeUnitoAsanaProdSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgeUnitoAsanaProdSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
